import axios from 'axios';

const updateDriver = params => axios.put('tickets/drivers', params);

export { updateDriver };
